import React from "react";
import TrackInfoTool from "../../../../components/tools/TrackInfoTool";
import { useQuery } from "@tanstack/react-query";
import { CircularProgress, Box } from "@mui/material";
import NotificationsSettingsService from "../../../../services/NotificationsSettingsService";
import { UserSettingsNotifications } from "../../../../components/settings/UserSettingsNotifications";
import { UserRole } from "../../../../constants";

export const CLIENT_NOTIFICATION_SETTINGS_QUERY_KEY =
  "client-notification-settings";

export function ClientSettingsNotificationRoute() {
  const { data: settings, isLoading } = useQuery({
    queryKey: [CLIENT_NOTIFICATION_SETTINGS_QUERY_KEY],
    queryFn: () =>
      NotificationsSettingsService.getCurrentUserNotificationsSettings(),
  });

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        settings && (
          <UserSettingsNotifications
            settings={settings}
            role={UserRole.CLIENT}
          />
        )
      )}
      <TrackInfoTool
        trackInfo={{
          name: "Client - Notifications Settings",
        }}
      />
    </>
  );
}
